import React, { useContext } from 'react'
import { Route, Redirect } from 'react-router'
import { SessionContext } from 'data/context';

export const PrivatePrint = ({ component: Component, ...rest }) => {
  const { ftusertype: details, readOnly } = useContext(SessionContext);
  const auth = (details === '1' || details === '2' || details === '4') && !readOnly
  return (
    <Route
      {...rest}
      render={props =>
        auth ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: '/'
            }}
          />
        )
      }
    />
  )
}
